<template>
  <div class="select-buttons">
    <div class="column">
      <div v-for="(option, index) in options" :key="index"
           class="button bg-riseup-white row items-center"
           :class="{ pressed: isSelected(index), small: size === 'sm', large: size === 'lg'}"
           v-touch:start="onPressStart(index)"
           v-touch:end="onPressEnd"
           @click.once="option.action(option)" >
        <div class="image-container">
          <img :src="option.img" />
        </div>
        <div v-if="option.label"
             class="r-text-regular label"
             :class="{'r-text-bold': isSelected(index)}" >
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectButtons',
  props: {
    options: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
      validator: val => ['sm', 'lg'].includes(val),
    },
  },
  data() {
    return {
      pressedIndex: null,
    };
  },
  methods: {
    isSelected(index) {
      return index === this.pressedIndex;
    },
    onPressStart(index) {
      return () => {
        this.pressedIndex = index;
      };
    },
    onPressEnd() {
      this.pressedIndex = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/styles/riseup.brand";

@mixin buttonCSS($height, $labelMargin, $imageWidth) {
  height: $height;

  .label {
    margin-left: $labelMargin;
  }

  .image-container {
    width: $imageWidth;
  }
}

.select-buttons {
  .button {
    margin-bottom: 4px;
    border-radius: 2px;
    padding: 11px 20px;

    &.small {
      @include buttonCSS(75px, 20px, 50px);
    }

    &.large {
      @include buttonCSS(150px, 60px, 100px);
    }

    &.pressed {
      background-color: $riseup-light_blue;
      color: $riseup-blue;
    }

    .image-container {
      display: flex;
      justify-content: center;
    }

  }
  .button:last-of-type {
    margin-bottom: 0;
  }
}

</style>
